module.exports = __webpack_public_path__ + "img/mas.efb7d3fe.png";